import { useService } from 'react-reservice';

import mixpanelAnalysisService from './service';

export * from './service';

export const useMixpanel = () => {
  return useService(mixpanelAnalysisService, (state) => state);
};

export { mixpanelAnalysisService };
